<template>
  <div>
    <v-layout wrap py-10 justify-center>
      <v-flex xs11 sm12>
        <span
          style="color: #000000; font-family: poppinssemibold; font-size: 25px"
          >Our Best Selling Products</span
        >
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex
        xs12
        sm12
        md12
        lg11
        px-2
        px-xs-2
        px-sm-2
        px-md-2
        px-lg-0
        px-xl-0
        v-if="relatedProducts.length > 0"
      >
        <v-layout wrap justify-start>
          <v-flex xs12 sm6 md3 px-3 pb-8 v-for="(list, l) in relatedProducts" :key="l">
           
            <v-card elevation="0">
             
              <v-layout wrap justify-center pb-8>
                <v-flex xs12>
                  <v-layout wrap justify-center>

                    <v-flex xs12 pt-6>
                      <v-flex xs11 sm11 md11 pl-15 align-self-center>
                        <v-layout
                          wrap
                          justify-end
                          align-center
                          fill-height
                        >
                          <v-flex xs2 sm3 md3 lg2 align-self-center>
                            
                              <v-layout wrap py-1  @click="addWishlist(list)">
                                <v-flex style="cursor:pointer" v-if="list.iswishlisted == true">
                                  <v-icon size="20" color="red"
                                    >mdi-heart</v-icon
                                  >
                                </v-flex>
                                <v-flex style="cursor:pointer" v-else>
                                  <v-icon size="20" 
                                    >mdi-heart-outline</v-icon
                                  >
                                </v-flex>
                              </v-layout>
                           
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-img
                        contain
                        height="160px"
                        :src="mediaURL + list.productImage[0]"
                      ></v-img>
                      <!-- :src="mediaUURL + list.photos[0]" -->
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              
            </v-card>
      
            <v-layout wrap justify-start>
              <v-flex xs12>
                <router-link
                :to="
                '/productDetails?productName=' +
                list.productName +
                '&id=' +
                list.productId
              "
              >
                <v-layout wrap px-2>
                  <!-- <v-flex xs12>
                                <span
                                  style="
                                    color: #bcb4b4;
                                    font-family: poppinsmedium;
                                    font-size: 12px;
                                  "
                                  >{{ list.name }}</span
                                >
                              </v-flex> -->
                              <v-flex xs9 sm6 md8 text-left pt-2>
                                <span
                                  style="
                                    color: #000000;
                                    font-family: poppinsmedium;
                                    font-size: 15px;
                                    text-transform: capitalize;
                                  "
                                  >{{ list.productName.slice(0, 15) }}</span
                                >
                                <span v-if="list.productName.length > 15"> ... </span>
                              </v-flex>
                              <v-flex xs3 sm6 md4 pt-2 text-right>
                                <span
                                  style="
                                    color: #000000;
                                    font-family: RobotoBold;
                                    font-size: 17px;
                                  "
                                >
                                ₹{{ list.productPrice }}</span
                                >
                              </v-flex>
            
                  <!-- <v-flex xs3 sm6 md4 pt-2 text-right>
                      <span
                        style="
                          color: #000000;
                          font-family: RobotoBold;
                          font-size: 17px;
                        "
                      >
                        ₹{{ list.productPrice }}</span
                      >
                    </v-flex> -->
                    <v-flex xs12 text-left>
                      <span
                        style="
                          color: #000000;
                          font-family: poppinsmedium;
                          font-size: 14px;
                        "
                        >{{ list.productSize }} {{ list.unit }}</span
                      >
                    </v-flex>
                    <v-flex xs12 text-left>
                    <v-layout wrap justify-start>
                      <v-flex xs4 sm4 md6 lg4>
                        <v-rating
                          hover
                          length="5"
                          size="18"
                          background-color="#F28F34"
                          color="#F28F34"
                          half-increments
                          v-model="list.productRating"
                        ></v-rating>
                      </v-flex>
                      <v-flex xs4 sm4 md6 lg8 text-left>
                        <span
                          style="
                            color: #2b2b2b;
                            font-family: poppinslight;
                            font-size: 12px;
                          "
                          >({{ list.reviewCount }})</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                    <!-- <v-flex xs12 text-left>
                      <span
                        style="
                          color: #000000;
                          font-family: poppinsmedium;
                          font-size: 14px;
                        "
                        >Stock: {{ product.stock }}</span
                      >
                    </v-flex> -->
                    <v-flex xs6 sm6 text-left pt-3>
                      <v-btn 
                        v-if="list.iscart==false"
                        color="#1D9A50"
                        dark
                        elevation="0"
                        rounded
                        :to="
                          '/productDetails?productName=' +
                          list.productName +
                          '&id=' +
                          list.productId
                        "
                      >
                        <span
                          style="
                            font-family: opensansbold;
                            text-transform: none;
                            font-size: 13px;
                            letter-spacing: 0px;
                          "
                        >
                          Add to Cart
                        </span>
                      </v-btn>
                    
                      <v-btn 
                        v-else
                        color="grey"
                        dark
                        elevation="0"
                        rounded
                      >
                        <span
                          style="
                            font-family: opensansbold;
                            text-transform: none;
                            font-size: 13px;
                            letter-spacing: 0px;
                          "
                        >
                          In Cart
                        </span>
                      </v-btn>
                    </v-flex>
                    
                </v-layout>
                </router-link>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- <v-layout wrap justify-center pt-2>
                  <v-flex xs12>
                    <div class="text-center pb-5" v-if="pages > 1">
                      <v-pagination
                        :length="pages"
                        :total-visible="7"
                        v-model="currentPage"
                        color="#30B868"
                        circle
                      ></v-pagination>
                    </div>
                  </v-flex>
                </v-layout> -->
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from 'axios';
export default {

  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      relatedProducts:[],
      lists: [
        {
          image: require("./../../assets/images/product1.png"),
          category: "Health",
          name: "Honey (Organic)",
          quantity: "500 Gm",
          price: "₹ 520",
          // price: "(₹ 620)",
        },
        {
          image: require("./../../assets/images/product2.png"),
          category: "Groceries ",
          name: "Pure Coconut Oil ",
          quantity: "500 ml",
          price: "₹ 250",
          // price: "(₹ 320)",
        },
        {
          image: require("./../../assets/images/product3.png"),
          category: "Personal Care",
          name: "Softening Creamy Soap Bar",
          quantity: "100 Gm",
          price: "₹ 120",
          // price: "(₹ 180)",
        },
        {
          image: require("./../../assets/images/product3.png"),
          category: "Personal Care",
          name: "Softening Creamy Soap Bar",
          quantity: "100 Gm",
          price: "₹ 120",
          // price: "(₹ 180)",
        },
      ],
    };
  },
  computed: {
    appUserId() {
      return this.$store.state.id;
    },
    UserId() {
      return this.$store.state.userId;
    },
  },
  beforeMount() {
     this.getProducts()
  },
  methods: {
    getProducts() {
      this.appLoading = true;
      axios({
        url: "/product/bestSelling",
        method: "POST",
        data: {
         // productId: this.$route.query.id,
          //productName: this.$route.query.productName,
          customerId:localStorage.getItem("id"),
          guestId: localStorage.getItem("userId"),
        },
        // headers: headers1,
      })
        .then((response) => {
          this.appLoading = false;
          this.relatedProducts = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          // this.ServerError = true;
          console.log(err);
        });
    },
    addWishlist(item) {
      this.appLoading = true;
     
      axios({
        url: "/user/wishList/Add",
        method: "POST",
       
        data: {
          productId: item.productId,
          customerId: localStorage.getItem("id"),
          guestId:localStorage.getItem("userId"),
          
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.product = response.data.data;
          this.$store.commit("changeWishlist", response.data.wishListCount);
          this.$emit("wishlistUpdated");
          this.pages = Math.ceil(response.data.totalLength / this.limit);
          this.getProducts();
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  }
};
</script>